import ApiUrl from 'services/shared/ApiUrl';

const DispalyImage = ({ imageUrl, imageSize }) => {

    if (imageUrl === '' || imageUrl === undefined) {
        return (
            <img className={imageSize} src='/images/photo.png' alt="" />
        )
    } else if (imageUrl !== '' && imageUrl !== undefined && imageUrl?.length > 0) {
        const split = imageUrl.split(".");
        const extension = split[split.length - 1];
        if (extension === 'pdf') {
            return ( <img className={imageSize} src='/images/pdf.png' alt="" /> )
        } else if (extension === 'xlsx') {
            return ( <img className={imageSize} src='/images/xls.png' alt="" /> )
        } else if (extension === 'txt') {
            return ( <img className={imageSize} src='/images/file.png' alt="" /> )
        } else if (extension === 'docx') {
            return ( <img className={imageSize} src='/images/word.png' alt="" /> )
        } else if (extension === 'jpg' || extension === 'png' || extension === 'jpeg' || extension === 'jpg' || extension === 'svg' || extension === 'webp' ){
            return (
                <img src={ApiUrl.fileBaseUrl+imageUrl} alt="" />
            )
        }
    }

}

export default DispalyImage